/* ==========================================================================
   YUNSO — comportements globaux
   Aucun framework, aucune dépendance externe. Tout est délégué ou initialisé
   au chargement, et ré-initialisable depuis l'éditeur de thème Shopify.
   ========================================================================== */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ------------------------------------------------------- En-tête collant */

  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    var wrap = header && header.closest('.header-wrap');
    if (!header || !wrap || wrap.dataset.sticky !== 'true') return;

    var hero = document.querySelector('.hero--full');
    var observer = null;

    function watch() {
      if (observer) observer.disconnect();

      if (hero) {
        // Bannière plein cadre : l'en-tête reste transparent tant que l'image
        // passe derrière lui, et ne se teinte qu'une fois la bannière dépassée.
        // Sinon le texte blanc deviendrait illisible dès le premier pixel.
        var h = Math.round(header.getBoundingClientRect().height);
        observer = new IntersectionObserver(
          function (entries) {
            header.classList.toggle('is-stuck', !entries[0].isIntersecting);
          },
          { rootMargin: '-' + h + 'px 0px 0px 0px', threshold: 0 }
        );
        observer.observe(hero);
        return;
      }

      // Sans bannière : on observe un repère placé à l'endroit exact où
      // l'en-tête commence à coller. Le parent doit être positionné, sinon
      // le repère se place en haut du document et l'en-tête se teinte dès
      // le premier pixel de défilement.
      var host = wrap.parentNode;
      if (getComputedStyle(host).position === 'static') {
        host.style.position = 'relative';
      }

      var sentinel = host.querySelector('[data-header-sentinel]');
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.setAttribute('aria-hidden', 'true');
        sentinel.setAttribute('data-header-sentinel', '');
        sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:100%;pointer-events:none;';
        host.insertBefore(sentinel, wrap);
      }

      observer = new IntersectionObserver(
        function (entries) {
          header.classList.toggle('is-stuck', !entries[0].isIntersecting);
        },
        { threshold: 0 }
      );
      observer.observe(sentinel);
    }

    watch();

    // La hauteur de l'en-tête change au point de rupture : le seuil doit suivre.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(watch, 200);
    });
  }

  /* --------------------------------------------------------- Menu mobile */

  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;

    var opener = document.querySelector('[data-mobile-nav-open]');
    var panel = nav.querySelector('.mobile-nav__panel');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      nav.dataset.open = 'true';
      document.body.classList.add('is-locked');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      nav.dataset.open = 'false';
      document.body.classList.remove('is-locked');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (lastFocused) lastFocused.focus();
    }

    if (opener) opener.addEventListener('click', open);

    nav.querySelectorAll('[data-mobile-nav-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || nav.dataset.open !== 'true') return;
      close();
    });

    // Piège de focus : le menu est un dialogue modal.
    nav.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || nav.dataset.open !== 'true') return;

      var focusables = panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* ------------------------------------------------------ Bandeau annonce */

  var parisClock = window.Intl && new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
  });

  // « AAAA-MM-JJTHH:MM », heure de Paris → instant absolu. On lit l'heure
  // qu'il serait à Paris si la valeur était en UTC, et on retire l'écart :
  // l'heure d'été est ainsi prise en compte sans table de fuseaux.
  function parisInstant(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value || '');
    if (!m || !parisClock) return NaN;
    var guess = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4], +m[5]);
    var p = {};
    parisClock.formatToParts(guess).forEach(function (part) { p[part.type] = part.value; });
    var seen = Date.UTC(+p.year, p.month - 1, +p.day, +p.hour, +p.minute);
    return guess - (seen - guess);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initAnnouncement(root) {
    var all = Array.prototype.slice.call(root.querySelectorAll('[data-announce-slide]'));
    var slides = all;
    var index = 0;
    var timer = null;
    var prev = root.querySelector('[data-announce-prev]');
    var next = root.querySelector('[data-announce-next]');

    var countdowns = all.filter(function (slide) {
      if (!slide.hasAttribute('data-countdown')) return false;
      slide._end = parisInstant(slide.dataset.countdown);
      slide._parts = {};
      slide.querySelectorAll('[data-cd]').forEach(function (el) {
        slide._parts[el.dataset.cd] = el;
      });
      return true;
    });

    // Messages à faire tourner : un compte à rebours épinglé encore en cours
    // occupe seul le bandeau, les autres reprennent la main à son échéance.
    function arrange() {
      var now = Date.now();
      var live = all.filter(function (slide) {
        return !slide.hasAttribute('data-countdown') || slide._end > now;
      });
      var pinned = live.filter(function (slide) { return slide.dataset.pinned === 'true'; });
      var current = slides[index];

      slides = pinned.length ? pinned : live;
      index = Math.max(0, slides.indexOf(current));

      all.forEach(function (slide) {
        slide.classList.toggle('is-active', slide === slides[index]);
      });
      if (prev) prev.hidden = slides.length < 2;
      if (next) next.hidden = slides.length < 2;
      root.hidden = slides.length === 0 && !(window.Shopify && window.Shopify.designMode);
    }

    function tick() {
      if (!root.isConnected) return clearInterval(clock);
      var now = Date.now();
      var expired = false;

      countdowns.forEach(function (slide) {
        var left = Math.max(0, Math.floor((slide._end - now) / 1000));
        if (!left && slides.indexOf(slide) !== -1) expired = true;

        var d = Math.floor(left / 86400);
        var parts = slide._parts;
        parts.d.hidden = d === 0;
        parts.d.firstChild.textContent = d;
        parts.h.firstChild.textContent = pad(Math.floor(left / 3600) % 24);
        parts.m.firstChild.textContent = pad(Math.floor(left / 60) % 60);
        parts.s.firstChild.textContent = pad(left % 60);
      });

      if (expired) {
        arrange();
        start();
      }
    }

    var clock = null;
    if (countdowns.length) {
      arrange();
      tick();
      clock = setInterval(tick, 1000);
    }

    function show(to) {
      if (slides.length < 2) return;
      slides[index].classList.remove('is-active');
      index = (to + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }

    function start() {
      if (root.dataset.autorotate !== 'true' || prefersReducedMotion.matches) return;
      stop();
      if (slides.length < 2) return;
      timer = setInterval(function () {
        show(index + 1);
      }, parseInt(root.dataset.interval, 10) || 5000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  }

  /* ----------------------------------------------------------- Accordéons */

  function initAccordion(trigger) {
    if (trigger.dataset.bound === 'true') return;
    trigger.dataset.bound = 'true';

    trigger.addEventListener('click', function () {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      var group = trigger.closest('[data-accordion-exclusive]');

      // Dans un groupe exclusif, ouvrir un panneau referme les autres.
      if (group && !isOpen) {
        group.querySelectorAll('.accordion__trigger[aria-expanded="true"]').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.dataset.open = 'false';
        });
      }

      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.dataset.open = String(!isOpen);
    });
  }

  /* ------------------------------------------------------ Pop-up d'information */

  // Un bouton [data-dialog-open] ouvre le <dialog> que désigne son
  // aria-controls. Échap le referme nativement ; un clic sur le fond aussi.
  function initDialogTrigger(trigger) {
    if (trigger.dataset.bound === 'true') return;
    trigger.dataset.bound = 'true';

    var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dialog || typeof dialog.showModal !== 'function') return;

    trigger.addEventListener('click', function () {
      dialog.showModal();
    });

    if (dialog.dataset.bound === 'true') return;
    dialog.dataset.bound = 'true';

    dialog.querySelectorAll('[data-dialog-close]').forEach(function (button) {
      button.addEventListener('click', function () { dialog.close(); });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  }

  /* ------------------------------------------------------------ Avant / après */

  // Glisser n'importe où dans le visuel déplace la poignée ; au clavier, la
  // poignée (role="slider") se pilote aux flèches, Début et Fin.
  function initBeforeAfter(root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var handle = root.querySelector('[data-before-after-handle]');
    var dragging = false;

    function set(pos) {
      pos = Math.max(0, Math.min(100, pos));
      root.style.setProperty('--ba-pos', pos + '%');
      if (handle) handle.setAttribute('aria-valuenow', String(Math.round(pos)));
    }

    function fromEvent(event) {
      var rect = root.getBoundingClientRect();
      set(((event.clientX - rect.left) / rect.width) * 100);
    }

    root.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      dragging = true;
      root.setPointerCapture(event.pointerId);
      fromEvent(event);
    });

    root.addEventListener('pointermove', function (event) {
      if (dragging) fromEvent(event);
    });

    function stop() { dragging = false; }
    root.addEventListener('pointerup', stop);
    root.addEventListener('pointercancel', stop);

    if (handle) {
      handle.addEventListener('keydown', function (event) {
        var current = Number(handle.getAttribute('aria-valuenow')) || 0;
        var steps = { ArrowLeft: -5, ArrowDown: -5, ArrowRight: 5, ArrowUp: 5 };
        if (event.key in steps) set(current + steps[event.key]);
        else if (event.key === 'Home') set(0);
        else if (event.key === 'End') set(100);
        else return;
        event.preventDefault();
      });
    }
  }

  /* ------------------------------------------------------ Cartes défilantes */

  function initCardsScroll(root) {
    var track = root.querySelector('[data-cards-track]');
    var nav = root.querySelector('[data-cards-nav]');
    var prev = root.querySelector('[data-cards-prev]');
    var next = root.querySelector('[data-cards-next]');
    if (!track || !nav || !prev || !next) return;

    // Une carte plus la gouttière : le pas exact d'un cran, quelle que soit
    // la largeur choisie par la feuille de style à ce point de rupture. La
    // première carte de la bande sert d'étalon, quel que soit son gabarit.
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function sync() {
      nav.hidden = !scrollable();
      // Une marge d'un pixel absorbe les arrondis du défilement fluide, qui
      // s'arrête rarement pile sur la valeur maximale.
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }

    function go(direction) {
      track.scrollBy({
        left: direction * step(),
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  }

  /* ---------------------------------------------------------- Compteur panier */

  // Met à jour la pastille du panier après un ajout en Ajax, sans recharger.
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      var link = el.closest('[data-cart-link]');
      if (link) {
        link.setAttribute('aria-label', link.getAttribute('aria-label').replace(/\(\d+\)/, '(' + count + ')'));
      }
    });
  }

  window.Yunso = window.Yunso || {};
  window.Yunso.updateCartCount = updateCartCount;

  /* ------------------------------------------------------------ Amorçage */

  function init(scope) {
    var root = scope || document;
    if (root === document) {
      initStickyHeader();
      initMobileNav();
    }
    root.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    root.querySelectorAll('.accordion__trigger').forEach(initAccordion);
    root.querySelectorAll('[data-dialog-open]').forEach(initDialogTrigger);
    root.querySelectorAll('[data-before-after]').forEach(initBeforeAfter);
    root.querySelectorAll('[data-cards-scroll]').forEach(initCardsScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // L'éditeur de thème remplace le DOM d'une section sans recharger la page.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
